import { cva, type VariantProps } from 'class-variance-authority';
import { forwardRef } from 'react';
import { cn } from '../utils/cn';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full text-[11px] font-medium leading-none px-2 py-1',
  {
    variants: {
      variant: {
        default: 'bg-ink-100 text-ink-700',
        verified: 'bg-gold-500 text-white font-bold',
        ai: 'bg-violet-100 text-violet-700 font-mono tracking-wide',
        pan: 'bg-ink-100 text-ink-700',
        gst: 'bg-ink-200 text-ink-800',
        aadhaar: 'bg-gold-50 text-gold-700',
        mca: 'bg-gold-100 text-gold-700',
        success: 'bg-green-50 text-green-700',
        violet: 'bg-violet-100 text-violet-700',
      },
    },
    defaultVariants: { variant: 'default' },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => (
    <span ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
  )
);
Badge.displayName = 'Badge';
